import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractDynamicForm, FormControlWrapper } from '../../../dynamic-form-abstract';
import { FormGroup } from '@angular/forms';
import { HierarchyService } from '../../../../../service/hierarchy.service';
import { Subscription } from 'rxjs';
import { HierarchyDto } from '../../../../../service/dto';
import { NzTreeNodeOptions } from 'ng-zorro-antd/tree';

@Component({
	selector: 'app-dynamic-form-input-hierarchy',
	standalone: false,
	templateUrl: './dynamic-form-input-hierarchy.component.html',
	styleUrl: './dynamic-form-input-hierarchy.component.scss'
})
export class DynamicFormInputHierarchyComponent implements OnInit, OnDestroy {
	@Input() wrapper!: FormControlWrapper;
	@Input() form!: FormGroup;
	@Input() inline: boolean = false;
	@Input() readonly = false;
	@Input() span = 0;
	toControlKey = AbstractDynamicForm.toControlKey;

	selectedId?: string;
	expandedKeys: string[] = [];
	nodes: NzTreeNodeOptions[] = [];
	subscription = new Subscription();
	constructor(private service: HierarchyService) { }
	ngOnInit(): void {
		const value = this.wrapper.element.value;
		this.subscription.add(this.service.hierarchy$.subscribe(item => {
			this.nodes = [this.toNode(this.service.fullHierarchy!)];
			this.selectedId = '' + (value ?? this.service.hierarchy!.id);
			this.expandedKeys = this.service.findHierarchyAndParents(+this.selectedId).map(item => "" + item.id);
		}));
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
	change(selectedId: string) {
		this.wrapper.element.value = +selectedId;
		this.wrapper.control.setValue(+selectedId);
		this.wrapper.control.markAsDirty();
		this.wrapper.control.markAsTouched();
		this.wrapper.control.updateValueAndValidity();
	}


	private toNode(input: HierarchyDto): NzTreeNodeOptions {
		return {
			title: input.name,
			key: '' + input.id,
			isLeaf: input.subHierarchies.length == 0,
			children: input.subHierarchies.map(item => this.toNode(item))
		};
	}

}
